import styled from "styled-components";
export const AdvancedSearchWrapper = styled.div`
  .filter-page {
    margin-top: 20px;
    .filters-header {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      background-color: ${({ theme }) => theme.body};
      padding: 10px;
    }
    .filters {
      background-color: ${({ theme }) => theme.box};
      border-radius: 10px;
      box-shadow: 0px 1px 10px #00000010;

      .filters-content {
        padding: 10px;
      }
    }
    .filters-result {
      background-color: ${({ theme }) => theme.box};
      border-radius: 10px;
      box-shadow: 0px 1px 1px #00000050;
      .results {
        padding: 10px;
        .file {
          border-radius: 5px;
          border: 1px solid ${({ theme }) => theme.box};
          box-shadow: 0px 1px 5px #00000050;
          background-color: ${({ theme }) => theme.body};
          .profile {
            border-left: 0.5px solid ${({ theme }) => theme.box};
            border-bottom: 1px solid ${({ theme }) => theme.box};
          }
          .major-details {
            border-bottom: 1px solid ${({ theme }) => theme.box};
          }
        }
      }
    }
    .ant-pagination {
      direction: ltr;
    }
    .ant-pagination-options {
      display: none !important;
    }
    .ant-pagination-item-link {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
